import React from "react";
import { useTranslation } from "react-i18next";

const AboutUs = () => {
  const { t } = useTranslation();
  
  return (
    <div className="flex items-center justify-center">
      <div
        className="flex flex-col md:flex-row items-center justify-center gap-2"
      >
        <div className="flex flex-col gap-2">
          <p className="text-[#1A2263] text-lg font-bold">
            {t('CtService')}
          </p>
          <p>
            {t('aboutUs.text')}
          </p>
        </div>
        <div>
          <img src="/assets/imgs/about-us.png" alt="about us" />
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
